{
 "_note": "Sorte von (H7): Produkt → übergeordnetes Produkt, eine Ebene. Wer das übergeordnete braucht („Nudeln“), kann eine Sorte nehmen (Spaghetti); umgekehrt nicht. Startwerte, nur wo eine Sorte im Rezept wirklich für das Allgemeine einspringt.",
 "kinds": {
  "spaghetti": "nudeln",
  "penne": "nudeln",
  "fusilli": "nudeln",
  "farfalle": "nudeln",
  "rigatoni": "nudeln",
  "tagliatelle": "nudeln",
  "linguine": "nudeln",
  "makkaroni": "nudeln",
  "orzo": "nudeln",
  "eiernudeln": "nudeln",
  "vollkornnudeln": "nudeln",
  "suppennudeln": "nudeln",
  "kirschtomate": "tomate",
  "rote-zwiebel": "zwiebel",
  "olivenoel": "oel",
  "weissweinessig": "essig",
  "rotweinessig": "essig",
  "apfelessig": "essig",
  "espresso": "kaffee",
  "schwarztee": "tee",
  "gruener-tee": "tee",
  "pfefferminztee": "tee",
  "kamillentee": "tee",
  "fruechtetee": "tee",
  "kraeutertee": "tee",
  "fencheltee": "tee",
  "rooibos": "tee"
 }
}
